<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">构建虚拟助手：AI数字人在家居自动化中的应用</h2>
                    <div class="time">2024-06-13 11:00:10</div>
                    <div class="start">
                        随着人工智能技术的飞速发展，人工智能数字人正逐渐成为家居自动化的重要代表。这些人工智能数字人不仅可以提供智能化的家居控制，还能与用户进行自然语言交互，实现智能家居的梦想

                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/330.png" alt="构建虚拟助手：AI数字人在家居自动化中的应用" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t">AI数字人在家居自动化中的应用</div>
                        <div class="list-text">
                            智能家居控制：AI数字人可以作为家庭智能助手，帮助用户控制家中的各种智能设备，如灯光、空调、窗帘等。用户可以通过语音或文字指令，告诉AI数字助手自己的需求，助手会根据指令自动执行相应的操作，实现智能化的家居控制。

                        </div>
                        <div class="list-text">
                            个性化服务：AI数字助手可以根据消费者的喜好和习惯，提供个性化的家居服务。 根据消费者日常行为和活动规律，AI数字助手可以自动调节家中的温度和湿度，为消费者提供更加舒适的居住环境。

                        </div>
                        <div class="list-text">
                            安全监控：AI数字助手可以作为家庭安全监控系统，帮助用户监测家中的安全状况。例如，当家中发生情况时，AI数字助手可以立即向用户发出警报，并采取相应的措施，确保家庭安全。

                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t">AI数字人在家居自动化中的应用将带来以下影响：</div>
                        <div class="list-text">
                            提升家居生活质量：AI数字助手可为用户提供更加智能、便捷的家居服务，提升家居生活的舒适度和便利性。
                        </div>
                        <div class="list-text">
                            节约能源资源：通过智能控制家庭设备的运行，AI数字助手探索用户节约能源资源，降低能源消耗。
                        </div>
                        <div class="list-text">
                            推动智能家居行业发展：人工智能数字人的应用将推动智能家居行业的发展，促进智能领域的技术创新和应用。
                        </div>
                    </div>

                    <div class="end">
                        AI数字人在家居自动化中的应用，将为人们带来智能化、便捷化的家居生活体验。随着人工智能技术的廉价，AI数字人的能力和应用场景将进一步拓展，为智能家居带来更多的可能性。我们期待着AI数字人在智能家居领域发挥更大的作用，为人们的生活带来更多便利和乐趣。

                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "构建虚拟助手：AI数字人在家居自动化中的应用-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "构建虚拟助手：AI数字人在家居自动化中的应用,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "随着人工智能技术的飞速发展，人工智能数字人正逐渐成为家居自动化的重要代表",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo330.vue